module.exports = __webpack_public_path__ + "img/simpleMeal.280a1a57.png";